export default "__VITE_ASSET__DdprbH4D__"